fx.ns("models", class ProductCalendar extends models.Creation {

    constructor(data) {
        super(data);

        this.product_type_id = models.ProductType.CALENDAR;
    }

    get extraScale() {
        return this.details == "v2" ? 5 : 1;
    }

    get isDesk() {
        return this.cover_option == "desk";
    }

    get innerPages() {
        if (!this.elements) return [];

        return this.elements.filter(function (page) { return page.typeid == 1; });
    }

    get totalPrice() {
        return (this.creationOption.price_base * fx.get("lang").tax).toFixed(2) + " €";
    }

    // TODO : depending of format
    get pageWidth() {
        let width;

        let shape = this.creationOption && this.creationOption.format ? this.creationOption.format.style : this.shape_option;

        switch (shape) {
            case "portrait":
            case "wall-single":
                width = 210 * this.extraScale;
                break;

            case "landscape":
            case "desk":
            case "wall-double":
                width = 300 * this.extraScale;
                break;
        }

        return width;
    }

    get pageHeight() {

        let height;

        let shape = this.creationOption && this.creationOption.format ? this.creationOption.format.style : this.shape_option;

        switch (shape) {
            case "portrait":
            case "wall-single":
                height = 300 * this.extraScale;
                break;

            case "landscape":
            case "desk":
            case "wall-double":
                height = 210 * this.extraScale;
                break;
        }

        return height;
    }

    get coverHeight() {
        return this.pageHeight;
    }

    get coverWidth() {
        return this.pageWidth;
    }

    get sliceHeight() {
        return 0;
    }

    get format() {
        return this.creationOption.format;
    }

    get option() {
        return this.creationOption.option;
    }

    get creationOption() {
        if (this.creationOptions)
            return this.creationOptions.find({ formatid: this.formatid, option_id: this.optionid })
        else
            return this._creationOption;
    }

    set creationOption(val) {
        this._creationOption = val;
    }

    get creationOptions() {
        return this._creationOptions;
    }

    set creationOptions(val) {
        this._creationOptions = val;
    }

    // landscape / portrait
    get orientation() {
        //return this.creationOption.format.style;

        let shape = this.creationOption && this.creationOption.format ? this.creationOption.format.style : this.shape_option;
        return shape;
    }

    // portrait and desk calendars show only one page
    get isSinglePage() {
        let option = this.creationOption && this.creationOption.option ? this.creationOption.option.code : this.cover_code;
        return this.orientation == "portrait" || option == "CALENDAR-DESK";
    }

    get hasWhole() {
        let option = this.creationOption && this.creationOption.option ? this.creationOption.option.code : this.cover_code;
        return option == "CALENDAR-WALL-DOUBLE";
        //return this.option.editor_code == "wall-double";
    }

    get hasHook() {
        let option = this.creationOption && this.creationOption.option ? this.creationOption.option.code : this.cover_code;
        return option == "CALENDAR-WALL-SINGLE";
        //return this.option.editor_code == "wall-single";    
    }

    get nonEditableCalendar() {
        let option = this.creationOption && this.creationOption.option ? this.creationOption.option.code : this.cover_code;
        return option == "CALENDAR-DESK";
        //return this.option.editor_code == "desk";    
    }

    get dates() {
        let dates = [];
        for (let i = 1; i < this.elements.length; i++) {
            let element = this.elements.getItemAt(i);
            let currentMonth;
            for (let j = 0; j < element.components.length; j++) {
                let component = element.components.getItemAt(j);

                if (component.component_type == "calendar") {
                    let data = JSON.parse(component.content);
                    //data.year
                    //data.month
                    //data.days

                    if (data.days.length > 0) {
                        if (!currentMonth) {
                            const date = new Date(data.year, data.month - 1);
                            let month = date.toLocaleString('default', { month: 'long' }).capitalize();
                            currentMonth = { month: data.month, year: data.year, monthLabel: month, label: month + " " + data.year, dates: [], component: component, element: element };
                        }

                        for (let i = 0; i < data.days.length; i++) {
                            if (data.days[i])
                                currentMonth.dates.push({ day: i, event: data.days[i] });
                        }

                    }
                }
            }

            if (currentMonth)
                dates.push(currentMonth);
        }

        return dates;
    }

    getMonthComponent(month) {
        for (let i = 1; i < this.elements.length; i++) {
            let element = this.elements.getItemAt(i);
            for (let j = 0; j < element.components.length; j++) {
                let component = element.components.getItemAt(j);

                if (component.component_type == "calendar") {
                    let data = JSON.parse(component.content);
                    if (data.month == month) {
                        return component;
                    }
                }
            }
        }
    }

    setStartingMonth(date) {
        // Le jour du mois est ignoré : gardé (ex. le 30), setMonth() débordait
        // sur les mois plus courts (30 février → 2 mars) et sautait février.
        date = new Date(date.getFullYear(), date.getMonth(), 1);

        for (let i = 1; i < this.elements.length; i++) {
            let element = this.elements.getItemAt(i);

            for (let j = 0; j < element.components.length; j++) {
                let component = element.components.getItemAt(j);

                if (component.component_type == "calendar") {
                    let data = JSON.parse(component.content);
                    data.month = date.getMonth() + 1;
                    data.year = date.getFullYear();

                    date.setMonth(data.month);

                    component.content = JSON.stringify(data);
                }
            }
        }
    }


    calculatePrice() {
        return this.totalPrice;
    }

});
